module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.9/_next/static/images/desenrola1x-f7825ad9730913f09e3ceeb6ae85f300.webp";